module.exports = __webpack_public_path__ + "static/comingsoon_w264xh200-b4716f35b6db4fdfa8856e27f149301d.png";